import InlineCta from "./InlineCta";
export default InlineCta;